<template>
    <div
      v-if="popup"
      class="feedBackPopup-wrapper"
    >
        <div class="popup" v-if="!success">
            <div @click="closePopup" class="closer">
                <font-awesome-icon class="icon close" icon="times"></font-awesome-icon>
            </div>
            <h3 class="popup-item popup-item-title">Обращение в поддержку</h3>
            <ModelString
                class="popup-item"
                label="Имя"
                v-model="popupData.name"
                :valid="validation.name.valid"
            ></ModelString>
            <ModelString
                class="popup-item"
                label="E-mail"
                v-model="popupData.email"
                :valid="validation.email.valid"
            ></ModelString>
            <ModelTextArea
                class="popup-item popup-item-textarea"
                label="Задайте вопрос"
                v-model="popupData.text"
                :valid="validation.text.valid"
            ></ModelTextArea>
            <ModelFile
                class="edu-file"
                label="Прикрепить документ"
                :value="document"
                @change="updateField('document', $event ? $event : null)"
            />
            <div class="popup-actions-row">
                <div class="feedBack-btn cancel" @click="closePopup">Отменить</div>
                <div class="feedBack-btn" @click="sendMessage">Отправить</div>
            </div>
        </div>
        <div v-else class="success">
            <h3 class="popup-item">Ваше сообщение отправлено</h3>
            <div class="text">Ответ будет отправлен на указанный вами e-mail</div>
            <button class="feedBack-btn" @click="closePopup">Понятно</button>
        </div>
    </div>
</template>

<script>
import ModelString from "@/components/UI/models/ModelString";
import ModelTextArea from "@/components/UI/models/ModelTextArea";
import ModelFile from "@/components/UI/models/ModelFile";
import { post } from "@/tools/http";
import { validation } from "@/tools/comparer";
import { mapGetters } from "vuex";

const getters = ["isMobile"];

export default {
    name: "FeedBackPopup",
    data: () => ({
        success: false,
        popupData: {
            name: "",
            email: "",
            text: "",
        },
        document: null,

        validation: {
            name: {
                reg: "empty",
                type: "hard",
                valid: true,
            },
            email: {
                reg: new RegExp(
                    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
                    "g"
                ),
                type: "hard",
                valid: true,
            },
            text: {
                reg: "empty",
                type: "hard",
                valid: true,
            },
        },
    }),
    computed: {
        ...mapGetters(getters),
    },

    mounted() {
        this.$nextTick(() => {
            const wrapper = this.$refs.refWrapper;
            console.log('wrapper', wrapper);
        });
    },

    methods: {
        closePopup() {
            this.$emit("close", false);
            this.success = false;
        },
        updateField (key, value) {
            console.log(key, value);
            this.document = value;
        },
        async sendMessage() {
            let badField = validation(this.popupData, this.validation);
            if (badField.length > 0) {
                badField.forEach(key => {
                    this.validation[key].valid = false;
                    setTimeout(() => {
                        this.validation[key].valid = true;
                    }, 1000);
                });
            } else {
                const data = {
                    ...this.popupData,
                    "attachment_url": this.document ? this.document.url : 'нет',
                    "device_local_time": (new Date()).toLocaleString(),
                    "device_screen_width": screen.width,
                    "device_screen_height": screen.height,
                    "device_window_inner_width": window.innerWidth,
                    "device_window_inner_height": window.innerHeight,
                };
                await post("notifications", "api/v1/support/moreThanTrip", data);
                this.success = true;
            }
        },
    },

    props: {
        popup: Boolean,
    },
    model: {
        prop: "popup",
        event: "close",
    },
    components: {
        ModelTextArea,
        ModelString,
        ModelFile,
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/rem";
@import "@/styles/mrem";
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.feedBackPopup-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background: rgba(1, 1, 1, 0.7);
    top: 0;
    left: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;

    .popup {
        width: rem(588);
        height: auto;
        background: #ffffff;
        border-radius: rem(4);
        padding: rem(40);
        position: relative;
        overflow-y: auto;

        .popup-item {
            margin-bottom: rem(40);
            width: 100%;
        }

        .popup-item:last-child {
            margin-bottom: 0;
        }
        h3 {
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(24);
            margin: 0;
            text-align: center;
        }
        &-actions-row {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            width: 100%;
        }
        .feedBack-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: white;
            width: rem(230);
            height: rem(48);
            background: #713DD3;
            border: 1px solid #713DD3;
            border-radius: rem(4);
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            cursor: pointer;

            &:first-child {
                background-color: transparent;
                color: #713DD3;
            }
        }

        .closer {
            position: absolute;
            top: rem(16);
            right: rem(24);
            z-index: 1001;
            padding: rem(8);
            cursor: pointer;
        }
    }

    .success {
        width: rem(588);
        height: auto;
        background: #ffffff;
        border-radius: rem(4);
        padding: rem(40);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        h3 {
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(24);
            margin: 0;
            text-align: center;
        }
        .text {
            text-align: center;
            font-family: "Open Sans", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            margin-top: 1rem;
        }

        .feedBack-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: white;
            width: rem(320);
            height: rem(48);
            border: 1px solid #713DD3;
            background: #713DD3;
            border-radius: rem(4);
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            margin-top: 1rem;
            cursor: pointer;
        }
    }
}

@import "@/styles/variables";

@media (max-width: $vm) {
    .feedBackPopup-wrapper {
        .popup {
            width: 90%;
            padding: mrem(40) mrem(16);
            border-radius: mrem(4);
            height: 77%;
            max-height: mrem(600);

            .popup-item-title {
                font-size: mrem(21);
                line-height: mrem(26);
                margin-bottom: mrem(32);
            }

            .popup-item {
                margin: 0 0 mrem(32) 0;
            }

            .closer {
                top: mrem(12);
                right: mrem(12);
                padding: mrem(8);
            }

            .svg-inline--fa {
                width: mrem(17);
                height: mrem(17);

                path {
                    fill: #98a0a9;
                }
            }

            .data-model.popup-item.popup-item-textarea {
                height: mrem(114);
                padding: mrem(10);
            }

            .data-model.popup-item {
                margin-bottom: mrem(40);
                border-radius: mrem(4);
                border: mrem(1) solid #d2d5d9;
                font-size: mrem(16);
                padding: mrem(13);
                height: mrem(48);
            }

            .feedBack-btn {
                width: 47%;
                height: mrem(46);
                margin: mrem(8) 0 0 0;
                font-size: mrem(16);
                line-height: mrem(20);
                border-radius: mrem(4);
            }
        }

        .success {
            width: 90%;
            padding: mrem(20) mrem(16);
            border-radius: mrem(4);

            .popup-item {
                font-size: mrem(21);
                line-height: mrem(26);
                margin-bottom: mrem(12);
            }

            .text {
                width: 80%;
                font-size: mrem(16);
                line-height: mrem(20);
                margin-bottom: mrem(25);
            }

            .feedBack-btn {
                width: 80%;
                height: mrem(46);
                margin: mrem(8) 0 0 0;
                font-size: mrem(16);
                line-height: mrem(20);
                border-radius: mrem(4);
            }
        }
    }
}
</style>
